export const openEndedTextAreaDataSet = { cy: 'open-ended-text-area' };
export const openEndedSubmitDataSet = { cy: 'open-ended-submit' };
